var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('element',[_c('element',[_c('ul',{staticClass:"aside-link"},_vm._l((_vm.menuData),function(item,idx){return _c('router-link',{key:idx,class:item.icon,attrs:{"active-class":"on","to":'/pages'+ item.link||'',"tag":"li"}},[_vm._v(_vm._s(item.title))])}),1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0daf12ba","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/TopMenu.vue
// module id = null
// module chunks = 